// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.PortalAnalyticsWebApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AnalyticsLastUpdatedResponseDto,
  PortfolioAnalyticsRequestDto,
  PortfolioAnalyticsResponseDto,
  SalesforceUserDto,
  SfhAccountLevelSpendRequestDto,
  SfhAccountLevelSpendResponseDto,
} from '../..';

export const PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_Path =
  '/api/web/portalAnalyticsPaths/getAnalyticsLastUpdatedDates';

export const PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates = (client = getClient()) => {
  return httpApiRequest<never, never, AnalyticsLastUpdatedResponseDto>(
    {
      endpoint: PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const PortalAnalyticsWebApiHandler_getPortfolioAnalytics_Path =
  '/api/web/portalAnalyticsPaths/getPortfolioAnalytics';

export const PortalAnalyticsWebApiHandler_getPortfolioAnalytics = (
  postData: PortfolioAnalyticsRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, PortfolioAnalyticsRequestDto, PortfolioAnalyticsResponseDto>(
    {
      endpoint: PortalAnalyticsWebApiHandler_getPortfolioAnalytics_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_Path =
  '/api/web/portalAnalyticsPaths/getSfhAccountLevelSpend';

export const PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend = (
  postData: SfhAccountLevelSpendRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, SfhAccountLevelSpendRequestDto, Array<SfhAccountLevelSpendResponseDto>>(
    {
      endpoint: PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const PortalAnalyticsWebApiHandler_getUserSalesProInfo_Path =
  '/api/web/portalAnalyticsPaths/getUserSalesProInfo';

export const PortalAnalyticsWebApiHandler_getUserSalesProInfo = (client = getClient()) => {
  return httpApiRequest<never, never, Array<SalesforceUserDto>>(
    {
      endpoint: PortalAnalyticsWebApiHandler_getUserSalesProInfo_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const PortalAnalyticsWebApiHandler_isPilotUser_Path = '/api/web/portalAnalyticsPaths/isPilotUser';

export const PortalAnalyticsWebApiHandler_isPilotUser = (client = getClient()) => {
  return httpApiRequest<never, never, boolean>(
    {
      endpoint: PortalAnalyticsWebApiHandler_isPilotUser_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
